// extracted by mini-css-extract-plugin
export var carrierTab = "_42-0";
export var carrierTabActive = "_42-1 _42-0";
export var carrierTabInactive = "_42-2 _42-0";
export var carrierTabLabel = "_42-3";
export var carrierTabLabelActive = "_42-4 _42-3";
export var carrierTabLabelInactive = "_42-5 _42-3";
export var carrierTabPercentage = "_42-6";
export var carrierTabPercentageActive = "_42-7 _42-6";
export var carrierTabPercentageInactive = "_42-8 _42-6";
export var carrierTabWinnable = "_42-9";
export var carrierTabWinnableActive = "_42-a _42-9";
export var carrierTabWinnableInactive = "_42-b _42-9";
export var comparisonContainer = "_42-d";
export var missingRateButton = "_42-n";
export var missingRateButtonActive = "_42-o _42-n";
export var missingRateButtonInactive = "_42-p _42-n";
export var missingRateButtonLabel = "_42-q";
export var missingRateButtonLabelActive = "_42-r _42-q";
export var missingRateButtonLabelInactive = "_42-s _42-q";
export var sidebar = "_42-c";
export var strategyButton = "_42-e";
export var strategyButtonActive = "_42-f _42-e";
export var strategyButtonDescription = "_42-k";
export var strategyButtonDescriptionActive = "_42-l _42-k";
export var strategyButtonDescriptionInactive = "_42-m _42-k";
export var strategyButtonInactive = "_42-g _42-e";
export var strategyButtonLabel = "_42-h";
export var strategyButtonLabelActive = "_42-i _42-h";
export var strategyButtonLabelInactive = "_42-j _42-h";
export var unitToggleButton = "_42-t";
export var unitToggleButtonActive = "_42-u _42-t";
export var unitToggleButtonInactive = "_42-v _42-t";
export var unitToggleButtonLabel = "_42-w";
export var unitToggleButtonLabelActive = "_42-x _42-w";
export var unitToggleButtonLabelInactive = "_42-y _42-w";